import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { ToastService } from '../../../Services/toast/toast.service';
import { environment } from '../../../../environments/environment.prod';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationComponent } from '../../../components/pagination/pagination.component';
import { ToastComponent } from '../../../components/toast/toast.component';
import { ComponentaddComponent } from './componentadd/componentadd.component';
import { QuestionControlService } from '../../../inputfileds/form_services/question-control.service';
import { Router } from 'express';
import { EcontentServicesService } from '../../../inputfileds/form_services/econtent-services/econtent-services.service';
import { Inputfiledsbase } from '../../../inputfileds/models/inputfiledsbase';
import { Observable } from 'rxjs';
import { ComponentdialogComponent } from './componentdialog/componentdialog.component';
import { ComponentserviceService } from '../../../inputfileds/form_services/component/componentservice.service';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-componentpageview',
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatTableModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    PaginationComponent,
    ToastComponent,
    ComponentaddComponent,
    TranslateDirective
  ],
  templateUrl: './componentpageview.component.html',
  styleUrl: './componentpageview.component.scss',
  providers: [ComponentserviceService, QuestionControlService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentpageviewComponent {
  componentlist = new MatTableDataSource<any>();
  sourcelist: any = [];
  displayedColumns: string[] = [
    'sl.no',
    'Title',
    'images',
    'status',
    'actions',
  ];
  total_count: any;
  paginationData: any;
  showForm: boolean = false;
  action: string = '';
  editdata: any;
  form!: FormGroup;
  questions: Inputfiledsbase<string>[] | null = [];
  questions$: Observable<Inputfiledsbase<any>[]> | null;
  accessUrl = environment.ASSET_URL + environment.ASSET_CONTAINER;

  constructor(
    private componentservice: ComponentserviceService,
    private qcs: QuestionControlService,
    private apiservice: ApiservicesService,
    private toast: ToastService,
    private dialog: MatDialog
  ) {
    this.questions$ = this.componentservice.getcomponentform();
    this.questions$.subscribe((questions) => {
      this.questions = questions;
      this.form = this.qcs.toFormGroup(
        this.questions as Inputfiledsbase<string>[]
      );
    });
  }

  ngOnInit(): void {
    this.getdata();
  }

  getdata() {
    this.apiservice.getComponentlist(this.paginationData).subscribe({
      next: (res: any) => {
        if (res) {
          this.sourcelist = res.rows;
          this.total_count = res.total_count;
          this.componentlist = new MatTableDataSource<any>(res.rows);
        } else {
          this.toast.showToast('danger', res.message);
          console.error('Error:', res.message || 'Unknown error');
        }
      },
      error: (err) => {
        this.toast.showToast('danger', err);
        console.error('Form submission failed:', err);
      },
    });
  }

  pagination(event: any) {
    this.paginationData = event;
    this.getdata();
  }

  addComponent(action: any) {
    this.action = action;
    this.editdata = {};
    this.form.reset(); // Reset form when adding new component
    this.showForm = !this.showForm;
  }

  updateComponent(element: any, action: string) {
    this.action = action;
    this.editdata = element;
    this.showForm = !this.showForm;
  }

  EDComponent(id: number, status: string) {
    let statusflag = '';
    if (status == 'ACTIVE') {
      status = 'INACTIVE';
      statusflag = 'Disable';
    } else {
      status = 'ACTIVE';
      statusflag = 'Enable';
    }
    const formData = new FormData();
    formData.append('status', status);
    const fleg = confirm(`You Want to ${statusflag} the record ?`);
    if (fleg) {
      this.apiservice.updateComponent(id, formData).subscribe({
        next: (res) => {
          if (res.status == true) {
            this.getdata();
            this.toast.showToast('success', res.message);
          }
        },
        error: (err) => {
          this.toast.showToast('danger', err);
          console.error('update failed:', err);
        },
      });
    }
  }

  onFormSubmit(form_data: any) {
    // Check if form_data exists and is FormData
    if (!form_data || !(form_data instanceof FormData)) {
      console.warn('Form data is empty or invalid. Skipping submission.');
      return;
    }
    form_data.forEach((value: any, key: string) => {
      console.log(key, value);
    });

    if (this.action == 'Add') {
      this.apiservice.createComponentData(form_data).subscribe({
        next: (res) => {
          if (res.status == true) {
            this.getdata();
            this.showForm = !this.showForm;
            this.toast.showToast('success', res.message);
            this.form.reset();
          } else {
            this.toast.showToast(
              'danger',
              res.message || 'Failed to create component'
            );
          }
        },
        error: (err) => {
          this.toast.showToast(
            'danger',
            err.message || 'Form submission failed'
          );
          console.error('Form submission failed:', err);
        },
      });
    }

    if (this.action == 'Update') {
      this.apiservice.updateComponent(this.editdata.id, form_data).subscribe({
        next: (res) => {
          if (res.status == true) {
            this.getdata();
            this.showForm = !this.showForm;
            this.toast.showToast('success', res.message);
            this.form.reset();
          } else {
            this.toast.showToast(
              'danger',
              res.message || 'Failed to update component'
            );
          }
        },
        error: (err) => {
          this.toast.showToast('danger', err.message || 'Update failed');
          console.error('Form submission failed:', err);
        },
      });
    }
  }

  OpenImg(path: string) {
    const dialogRef = this.dialog.open(ComponentdialogComponent, {
      width: '40vw',
      height: '60vh',
      data: { path: path },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getdata();
    });
  }

  navigateToBackPage() {
    this.showForm = !this.showForm;
  }
}
